import {
  EMF, FINGERPRINTS, TEMPERATURE, DOTS,
  GHOST_WRITING, GHOST_ORB, SPIRIT_BOX,
} from './evidences';

const ghosts = [
  {
    name: 'ghost.banshee.name',
    evidences: [FINGERPRINTS, GHOST_ORB, DOTS],
    strength: 'ghost.banshee.strength',
    weakness: 'ghost.banshee.weakness',
    wikiURL: 'https://phasmophobia.fandom.com/wiki/Banshee',
  },
  {
    name: 'ghost.demon.name',
    evidences: [FINGERPRINTS, GHOST_WRITING, TEMPERATURE],
    strength: 'ghost.demon.strength',
    weakness: 'ghost.demon.weakness',
    wikiURL: 'https://phasmophobia.fandom.com/wiki/Demon',
  },
  {
    name: 'ghost.deogen.name',
    evidences: [SPIRIT_BOX, GHOST_WRITING, DOTS],
    strength: 'ghost.deogen.strength',
    weakness: 'ghost.deogen.weakness',
    wikiURL: 'https://phasmophobia.fandom.com/wiki/Deogen',
  },
  {
    name: 'ghost.goryo.name',
    evidences: [EMF, FINGERPRINTS, DOTS],
    strength: 'ghost.goryo.strength',
    weakness: 'ghost.goryo.weakness',
    wikiURL: 'https://phasmophobia.fandom.com/wiki/Goryo',
  },
  {
    name: 'ghost.hantu.name',
    evidences: [FINGERPRINTS, GHOST_ORB, TEMPERATURE],
    strength: 'ghost.hantu.strength',
    weakness: 'ghost.hantu.weakness',
    wikiURL: 'https://phasmophobia.fandom.com/wiki/Hantu',
  },
  {
    name: 'ghost.jinn.name',
    evidences: [EMF, FINGERPRINTS, TEMPERATURE],
    strength: 'ghost.jinn.strength',
    weakness: 'ghost.jinn.weakness',
    wikiURL: 'https://phasmophobia.fandom.com/wiki/Jinn',
  },
  {
    name: 'ghost.mare.name',
    evidences: [SPIRIT_BOX, GHOST_ORB, GHOST_WRITING],
    strength: 'ghost.mare.strength',
    weakness: 'ghost.mare.weakness',
    wikiURL: 'https://phasmophobia.fandom.com/wiki/Mare',
  },
  {
    name: 'ghost.moroi.name',
    evidences: [SPIRIT_BOX, TEMPERATURE, GHOST_WRITING],
    strength: 'ghost.moroi.strength',
    weakness: 'ghost.moroi.weakness',
    wikiURL: 'https://phasmophobia.fandom.com/wiki/Moroi',
  },
  {
    name: 'ghost.myling.name',
    evidences: [EMF, FINGERPRINTS, GHOST_WRITING],
    strength: 'ghost.myling.strength',
    weakness: 'ghost.myling.weakness',
    wikiURL: 'https://phasmophobia.fandom.com/wiki/Myling',
  },
  {
    name: 'ghost.obake.name',
    evidences: [EMF, FINGERPRINTS, GHOST_ORB],
    strength: 'ghost.obake.strength',
    weakness: 'ghost.obake.weakness',
    wikiURL: 'https://phasmophobia.fandom.com/wiki/Obake',
  },
  {
    name: 'ghost.oni.name',
    evidences: [EMF, TEMPERATURE, DOTS],
    strength: 'ghost.oni.strength',
    weakness: 'ghost.oni.weakness',
    wikiURL: 'https://phasmophobia.fandom.com/wiki/Oni',
  },
  {
    name: 'ghost.onryo.name',
    evidences: [SPIRIT_BOX, GHOST_ORB, TEMPERATURE],
    strength: 'ghost.onryo.strength',
    weakness: 'ghost.onryo.weakness',
    wikiURL: 'https://phasmophobia.fandom.com/wiki/Onryo',
  },
  {
    name: 'ghost.phantom.name',
    evidences: [SPIRIT_BOX, FINGERPRINTS, DOTS],
    strength: 'ghost.phantom.strength',
    weakness: 'ghost.phantom.weakness',
    wikiURL: 'https://phasmophobia.fandom.com/wiki/Phantom',
  },
  {
    name: 'ghost.poltergeist.name',
    evidences: [SPIRIT_BOX, FINGERPRINTS, GHOST_WRITING],
    strength: 'ghost.poltergeist.strength',
    weakness: 'ghost.poltergeist.weakness',
    wikiURL: 'https://phasmophobia.fandom.com/wiki/Poltergeist',
  },
  {
    name: 'ghost.raiju.name',
    evidences: [EMF, GHOST_ORB, DOTS],
    strength: 'ghost.raiju.strength',
    weakness: 'ghost.raiju.weakness',
    wikiURL: 'https://phasmophobia.fandom.com/wiki/Raiju',
  },
  {
    name: 'ghost.revenant.name',
    evidences: [GHOST_ORB, GHOST_WRITING, TEMPERATURE],
    strength: 'ghost.revenant.strength',
    weakness: 'ghost.revenant.weakness',
    wikiURL: 'https://phasmophobia.fandom.com/wiki/Revenant',
  },
  {
    name: 'ghost.shade.name',
    evidences: [EMF, GHOST_WRITING, TEMPERATURE],
    strength: 'ghost.shade.strength',
    weakness: 'ghost.shade.weakness',
    wikiURL: 'https://phasmophobia.fandom.com/wiki/Shade',
  },
  {
    name: 'ghost.spirit.name',
    evidences: [EMF, SPIRIT_BOX, GHOST_WRITING],
    strength: 'ghost.spirit.strength',
    weakness: 'ghost.spirit.weakness',
    wikiURL: 'https://phasmophobia.fandom.com/wiki/Spirit',
  },
  {
    name: 'ghost.thaye.name',
    evidences: [GHOST_ORB, GHOST_WRITING, DOTS],
    strength: 'ghost.thaye.strength',
    weakness: 'ghost.thaye.weakness',
    wikiURL: 'https://phasmophobia.fandom.com/wiki/Thaye',
  },
  {
    name: 'ghost.mimic.name',
    evidences: [SPIRIT_BOX, FINGERPRINTS, TEMPERATURE, GHOST_ORB],
    strength: 'ghost.mimic.strength',
    weakness: 'ghost.mimic.weakness',
    wikiURL: 'https://phasmophobia.fandom.com/wiki/The_Mimic',
  },
  {
    name: 'ghost.twins.name',
    evidences: [EMF, SPIRIT_BOX, TEMPERATURE],
    strength: 'ghost.twins.strength',
    weakness: 'ghost.twins.weakness',
    wikiURL: 'https://phasmophobia.fandom.com/wiki/The_Twins',
  },
  {
    name: 'ghost.wraith.name',
    evidences: [EMF, SPIRIT_BOX, DOTS],
    strength: 'ghost.wraith.strength',
    weakness: 'ghost.wraith.weakness',
    wikiURL: 'https://phasmophobia.fandom.com/wiki/Wraith',
  },
  {
    name: 'ghost.yokai.name',
    evidences: [SPIRIT_BOX, GHOST_ORB, DOTS],
    strength: 'ghost.yokai.strength',
    weakness: 'ghost.yokai.weakness',
    wikiURL: 'https://phasmophobia.fandom.com/wiki/Yokai',
  },
  {
    name: 'ghost.yurei.name',
    evidences: [GHOST_ORB, TEMPERATURE, DOTS],
    strength: 'ghost.yurei.strength',
    weakness: 'ghost.yurei.weakness',
    wikiURL: 'https://phasmophobia.fandom.com/wiki/Yurei',
  },
];

export default ghosts;
